import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TrashIcon } from '../../../assets/icons/chat-icons/trash2-fill.svg';
import CustomButton from '../../../components/button/CustomButton';
import CustomModal from '../../../components/modal/CustomModal';
import { useRefresh } from '../../../utils/hooks/crud-hooks/useRefresh';
import FramedIcon from '../FramedIcon';
import useDeleteOne from '../../../utils/hooks/crud-hooks/useDeleteOne';

type DeleteChannelModalProps = {
  open: boolean;
  onClose?: () => void;
  channelId: string;
};

export default ({ open, onClose, channelId }: DeleteChannelModalProps) => {
  const refresh = useRefresh();
  const { t } = useTranslation();
  const { mutate } = useDeleteOne({
    resource: 'channels',
  });
  const onSubmit = () => {
    mutate(
      {
        id: channelId,
      },
      {
        onSuccess: () => {
          refresh();
          onClose?.();
        },
      },
    );
  };

  return (
    <>
      <CustomModal open={open} onClose={onClose}>
        <Stack spacing={3}>
          <Stack direction="row" alignItems="center" spacing={2} width="100%">
            <FramedIcon Icon={TrashIcon} variant="pink" />
            <Typography variant="heading3">{t('chat.deleteChannel')}</Typography>
          </Stack>
          <Divider />
          <Typography variant="body2" color="primaryDark.600">
            {t('chat.deleteChannelText')}
          </Typography>
          <Divider />
          <Stack spacing={2} direction="row" sx={{ justifyContent: 'right' }}>
            <CustomButton variant="secondary" onClick={onClose}>
              {t('common.cancel')}
            </CustomButton>
            <CustomButton onClick={onSubmit}>{t('common.confirm')}</CustomButton>
          </Stack>
        </Stack>
      </CustomModal>
    </>
  );
};
